'use client'

import { CookiePolicy, useOpenCookieBanner } from '@artus_engineering/react-gdpr-cookie-consent'
import { Button } from '@tebuto/buttons/Button'

export function Cookies() {
    const handleOpenCookieBanner = useOpenCookieBanner()

    return (
        <>
            <p>
                Unsere Webseite verwendet Cookies, um technisch notwendige Funktionen bereitzustellen und, nach Ihrer
                Einwilligung, die Nutzung mit PostHog zu analysieren. Im Folgenden finden Sie eine Übersicht der von uns
                verwendeten Cookies, deren Zweck und wie lange sie gespeichert werden.
            </p>
            <Button onClick={handleOpenCookieBanner} className="mt-6">
                Cookie-Einstellungen öffnen
            </Button>
            <CookiePolicy />
        </>
    )
}
